import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import useUserContext from "Contexts/user-context";
import useCustomerContext from "Contexts/customer-context";
import { useGlobalNotificationBanner } from "Shared/util/custom-hooks";
import TextLink from "Shared/components/text-link";

export const useGlobalAnnualKycFollowUpBanners = () => {
    const history = useHistory();
    const location = useLocation();
    const { user, loaded } = useUserContext();
    const { customerData } = useCustomerContext();
    const {
        NotificationBannerType,
        addGlobalNotificationBanner,
        removeGlobalNotificationBanner,
    } = useGlobalNotificationBanner();

    const isAdmin = loaded && user?.activeCompany.role.isAdmin;

    useEffect(() => {
        if (!customerData?.annualKycFollowUp) return;

        const { due, passedDue } = customerData.annualKycFollowUp;

        const bannerId = "ANNUAL_KYC_FOLLOW_UP";
        const hideBanner =
            !isAdmin ||
            location.pathname === "/company-settings/annual-kyc" ||
            (!due && !passedDue);

        if (hideBanner) {
            removeGlobalNotificationBanner(bannerId);
        } else if (passedDue) {
            addGlobalNotificationBanner(
                (tnb) => (
                    <>
                        {`${tnb.annual_kyc_follow_up_passed_due} `}
                        <TextLink
                            text={tnb.annual_kyc_follow_up_link}
                            link={() =>
                                history.push("/company-settings/annual-kyc")
                            }
                        />
                    </>
                ),
                NotificationBannerType.Error,
                false,
                bannerId,
            );
        } else if (due) {
            addGlobalNotificationBanner(
                (tnb) => (
                    <>
                        {`${tnb.annual_kyc_follow_up_due} `}
                        <TextLink
                            text={tnb.annual_kyc_follow_up_link}
                            link={() =>
                                history.push("/company-settings/annual-kyc")
                            }
                        />
                    </>
                ),
                NotificationBannerType.Attention,
                false,
                bannerId,
            );
        }
    }, [customerData?.annualKycFollowUp, location.pathname, isAdmin]);
};
